import { useState } from "react";
import { useParentCompany, PARENT_COMPANY_DEFAULT_TEXT } from "@/hooks/useSiteMedia";

/** "Onderdeel van ..." met logo en backlink naar het moederbedrijf (instelbaar door admin). */
export function ParentCompanyBadge({ className = "" }: { className?: string }) {
  const { data } = useParentCompany();
  const [squareLogo, setSquareLogo] = useState(false);
  if (!data?.parent_logo && !data?.parent_url && !data?.parent_text) return null;
  const text = data.parent_text || PARENT_COMPANY_DEFAULT_TEXT;
  const inner = (
    <>
      {data.parent_logo && (
        <span className={`relative block shrink-0 overflow-hidden ${squareLogo ? "h-12 w-44 sm:w-56" : "h-10 max-w-56"}`}>
          <img
            src={data.parent_logo}
            alt="Logo Deer Peter B.V."
            className={squareLogo ? "absolute left-0 top-1/2 w-full max-w-none -translate-y-1/2" : "h-full w-auto max-w-full object-contain"}
            loading="lazy"
            onLoad={(event) => {
              const image = event.currentTarget;
              setSquareLogo(image.naturalWidth > 0 && image.naturalHeight / image.naturalWidth > 0.8);
            }}
          />
        </span>
      )}
      <span>{text}</span>
    </>
  );
  const cls = `inline-flex flex-wrap items-center gap-2 text-sm ${className}`;
  return data.parent_url ? (
    <a href={data.parent_url} target="_blank" rel="noopener" className={`${cls} hover:underline`}>{inner}</a>
  ) : (
    <span className={cls}>{inner}</span>
  );
}
